import React from 'react'
import MyProfile from '../../modules/MyProfile'

const Index = () => {
  return <MyProfile />
}

export default Index
